module.exports = __webpack_public_path__ + "img/bg-2.a76b2de0.jpg";